<template>
  <div :id="identifier" class="optionsEdit absolute" v-if="show">
    <ul>
      <li>
        <button @click.stop="edit">
          <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="15.608" viewBox="0 0 13.5 15.608">
            <path id="vector" d="M6.209,2.5.311,9.859a.711.711,0,0,0-.171.418L0,13.3a.766.766,0,0,0,.787.687l3-.711a.733.733,0,0,0,.385-.244L10.212,5.5m-4-3L7.8.52A1.2,1.2,0,0,1,9.429.2l2.237,1.862A1.153,1.153,0,0,1,11.657,3.7L10.212,5.5m-4-3a3.56,3.56,0,0,0,4,3" transform="translate(0.75 0.854)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          <translate>Edit Prompt</translate></button>
      </li>
      <li>
        <button @click.stop="deletePrompt">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.121" height="12.121" viewBox="0 0 12.121 12.121">
            <path id="Vector" d="M0,10,5,5M5,5l5-5M5,5l5,5M5,5,0,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          <translate>Delete Prompt</translate>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: crypto.randomUUID(),
    }
  },
  props: ['show'],
  computed: {
    identifier () {
      return this.id
    }
  },
  methods: {
    closeDropdownOnOutsideClick () {
      document.addEventListener('click', (e) => {
        if (document.getElementById(this.id) && !document.getElementById(this.id).contains(e.target)) {
          this.$emit('update:show',false)

        }
      })
    },
    close () {
      this.$emit('update:show',false)
    },
    edit () {
      this.$emit('onEdit')
      this.close()
    },
    deletePrompt () {
      this.$emit('onDelete')
      this.close()
    }
  },
  mounted() {
    this.closeDropdownOnOutsideClick()
  }
}
</script>
<style scoped>
.optionsEdit {
  border-radius: 8px;
  border: 1px solid #8367DF;
  background-color: #fff;
  right: 0;
  padding: 16px;
  font-size: 12px;
  width: 150px;
  z-index: 10;
  ul{
    list-style: none;
    margin: 0;
    text-align: left;
    padding-left: 0;
    li{
      &:first-child{
        margin-bottom: 10px;

      }
      button{
        display: flex;
        align-items: center;
        justify-content: left;
        gap: 0.5rem;
      }
    }
  }
}
</style>
